/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ChangeDB.css';


class ChangeDB extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      date: '',
      db: '',
      fa: '',
      value: '',
      DBdataJson: [],
      DBdataApi: null,

      historyJson: [],
      todayJson: [],
      favorabilityJson: [],

      acDate: ''
    }
    this.getBrandInfo = this.getBrandInfo.bind(this)
    this.saveToState = this.saveToState.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.changeToState = this.changeToState.bind(this)
  }

  componentDidMount() {
    this.getBrandInfo(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.getBrandInfo(nextProps)
      this.setState({ acDate: nextProps.time })
    }
  }

  handleChange = (items, modules) => {

    const { DBdataJson, DBdataApi } = this.state
    // console.log('POST参数==>',items)

    let [changeArr, changeNum] = [[], null]

    try {
      for (let i in items) {
        changeNum = items[i] != DBdataApi[modules][i] ? changeArr.push(`&${i}=${items[i]}`) : null
        // changeArr.concat(changeNum)
      }
    } catch (e) {
      console.log(e)
    }


    // console.log(changeArr,changeArr.join(''))





    if (changeArr.length > 0) {

      const url = `/digitalAssets/handleChange?brandId=${this.props.id}&statisDate=${this.props.time}&modules=${modules}${changeArr.join('')}`
      const myInit = {
        method: 'POST',
        // body:JSON.stringify(items),
        credentials: 'include',
        mode: 'cors',
        cache: 'no-cache'
      };
      console.log('url==>', url)
      console.log('请求头==>', myInit)
      fetch(url, myInit).then(response => response.json())
        .then(data => {
          if (data) {
            alert(`${this.props.name}提交成功`)
          }
        })
        .catch(e => {
          console.log("Oops, error", e)
          alert('提交失败')
        })
    } else {
      alert('数据未更改')
    }

  }

  getBrandInfo = ({ id, time }) => {
    const url = `/digitalAssets/getDb?brandId=${id}&statisDate=${time}`;
    const myInit = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache'
    };
    console.log(url, 'url')
    fetch(url, myInit).then(response => response.json())
      .then(DBdata => {
        this.setState({
          DBdataJson: DBdata || [],
          DBdataApi: JSON.parse(JSON.stringify(DBdata)) || {},

          historyJson: DBdata.history || {},
          todayJson: DBdata.today || {},
          favorabilityJson: DBdata.favorability || {},
        })
      })
      .catch(e => {
        console.log("Oops, error", e)

      })
  }

  saveToState = (e) => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
  }

  changeToState = (e) => {
    const { DBdataJson, historyJson, todayJson, favorabilityJson } = this.state
    const { name, value } = e.target

    if (name.substr(0, 2) == 'hi') {
      historyJson[name.substr(2, 4)] = value
      this.setState({
        historyJson
      })
    } else if (name.substr(0, 2) == 'to') {
      todayJson[name.substr(2, 4)] = value
      this.setState({
        todayJson
      })
    } else if (name.substr(0, 2) == 'fa') {
      favorabilityJson[name.substr(2, 4)] = value
      this.setState({
        favorabilityJson
      })
    }
  }

  render() {
    const { acDate, historyJsonWx, historyJson, todayJson, favorabilityJson, DBdataJson, date, new_dbwx, new_dbwb, new_dbzh, new_dbtt, new_dbwk, new_fawx, new_fawb, new_fazh, new_fatt, new_value, new_fawk, db, fa } = this.state

    return (
      <div className={this.props.show ? s.root : s.hide}>
        <div className={s.bgBox}>
          <form className={s.box}>
            <h2>
              {this.props.name}{this.props.time}
              {/* <input defaultValue={this.props.time} value={acDate} onChange={(e)=>this.setState({acDate:e.target.value})} /> */}
            </h2>
            <div className={s.flexBox}>

              <ul>
                <div>DB值（历史）</div>
                <li>
                  <label>总值：</label>
                  <input type='text' name='hitotal' value={historyJson.total} disabled />
                </li>
                <li>
                  <label>微信：</label>
                  <input type='text' name='hiwx' value={historyJson.wx} onChange={this.changeToState} />
                </li>
                <li>
                  <label>微博：</label>
                  <input type='text' name='hiwb' value={historyJson.wb} onChange={this.changeToState} />
                </li>
                <li>
                  <label>知乎：</label>
                  <input type='text' name='hizh' value={historyJson.zh} onChange={this.changeToState} />
                </li>
                <li>
                  <label>头条：</label>
                  <input type='text' name='hitt' value={historyJson.tt} onChange={this.changeToState} />
                </li>
                <li>
                  <label>悟空：</label>
                  <input type='text' name='hiwk' value={historyJson.wk} onChange={this.changeToState} />
                </li>
                <div>
                  <input type='button' name='yes' value='提交' onClick={() => this.handleChange(historyJson, 'history')} />
                  <input type='button' name='no' value='取消' onClick={this.props.close} />
                </div>
              </ul>
              <ul>
                <div>DB值（今日）</div>
                <li>
                  <label>总值：</label>
                  <input type='text' name='tototal' value={todayJson.total} disabled />
                </li>
                <li>
                  <label>微信：</label>
                  <input type='text' name='towx' value={todayJson.wx} onChange={this.changeToState} />
                </li>
                <li>
                  <label>微博：</label>
                  <input type='text' name='towb' value={todayJson.wb} onChange={this.changeToState} />
                </li>
                <li>
                  <label>知乎：</label>
                  <input type='text' name='tozh' value={todayJson.zh} onChange={this.changeToState} />
                </li>
                <li>
                  <label>头条：</label>
                  <input type='text' name='tott' value={todayJson.tt} onChange={this.changeToState} />
                </li>
                <li>
                  <label>悟空：</label>
                  <input type='text' name='towk' value={todayJson.wk} onChange={this.changeToState} />
                </li>
                <div>
                  <input type='button' name='yes' value='提交' onClick={() => this.handleChange(todayJson, 'today')} />
                  <input type='button' name='no' value='取消' onClick={this.props.close} />
                </div>
              </ul>
              <ul>
                <div>好感度</div>
                <li>
                  <label>总值：</label>
                  <input type='text' name='fatotal' value={favorabilityJson.total} disabled />
                </li>
                <li>
                  <label>微信：</label>
                  <input type='text' name='fawx' value={favorabilityJson.wx} onChange={this.changeToState} />
                </li>
                <li>
                  <label>微博：</label>
                  <input type='text' name='fawb' value={favorabilityJson.wb} onChange={this.changeToState} />
                </li>
                <li>
                  <label>知乎：</label>
                  <input type='text' name='fazh' value={favorabilityJson.zh} onChange={this.changeToState} />
                </li>
                <li>
                  <label>头条：</label>
                  <input type='text' name='fatt' value={favorabilityJson.tt} onChange={this.changeToState} />
                </li>
                <li>
                  <label>悟空：</label>
                  <input type='text' name='fawk' value={favorabilityJson.zh} onChange={this.changeToState} />
                </li>
                <div>
                  <input type='button' name='yes' value='提交' onClick={() => this.handleChange(favorabilityJson, 'favorability')} />
                  <input type='button' name='no' value='取消' onClick={this.props.close} />
                </div>
              </ul>
            </div>

          </form>
        </div>
      </div>
    )
  }
}

export default withStyles(s)(ChangeDB);



// WEBPACK FOOTER //
// src/components/ChangeDB/ChangeDB.js